import React, {Component} from 'react';
import {
  Row,
  Col,
  Grid,
  Panel,
  PanelBody,
  PanelHeader,
  PanelContainer,
  Icon,
  Button,
  PanelFooter,
} from '@sketchpixy/rubix';
import {routeUrl} from './routeUrl';

export default class Unauthorized extends Component {

  constructor(props) {
    super(props);

    this.goToMain = this.goToMain.bind(this);
    this.goToSignin = this.goToSignin.bind(this);
  }

  goTo = (where) => {
    let url = location.href;
    let base = url.split('/')[0];
    location.href = base + where;
  };

  goToMain = () => {
    this.goTo(routeUrl.dashboard);
  };

  goToSignin = () => {
    this.goTo(routeUrl.login);
  };

  render() {
    return (
        <div id="auth-container">
          <Row style={{marginTop: '10vh'}}>
            <Col sm={6} smOffset={3}>
              <PanelContainer controls={false}>
                <Panel>
                  <PanelHeader className='bg-pinkishred fg-white'>
                    <Grid>
                      <Row>
                        <Col xs={12}>
                          <h3>
                            <Icon glyph='icon-fontello-alert' />
                            &nbsp; Notice
                          </h3>
                        </Col>
                      </Row>
                    </Grid>
                  </PanelHeader>
                  <PanelBody>
                    <Grid>
                      <Row>
                        <Col xs={12}>
                          <h3>Access is denied.</h3>
                          <h3>due to invalid credentails.</h3>
                        </Col>
                      </Row>
                    </Grid>
                  </PanelBody>
                  <PanelFooter className='bg-pinkishred'>
                    <Grid>
                      <Row>
                        <Col xs={12} className='fg-white'>
                          <div style={{marginTop: '15px', marginBottom: '15px', textAlign: 'center'}}>
                            <Button
                                bsStyle="brownishgray"
                                bsSize="large" style={{marginRight: '40px'}}
                                onClick={this.goToMain}
                            >
                              <Icon glyph='icon-stroke-gap-icons-Goto' />
                              &nbsp;Go to main page
                            </Button>
                            <Button bsStyle='brownishgray' bsSize="large" onClick={this.goToSignin}>
                              <Icon glyph='icon-simple-line-icons-login' />
                              &nbsp;Go to sign in
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Grid>
                  </PanelFooter>
                </Panel>
              </PanelContainer>
            </Col>
          </Row>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Unauthorized.js